import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

interface TrusteeWelcomeModalProps {
  open: boolean;
  firstName: string;
  onDismiss: (markSeen: boolean) => void;
}

const steps = [
  "Set your Expense Approval policy and threshold in the Policies tab.",
  "Set your Float Counting policy (e.g. require two counters).",
  "Set your Asset Auditing policy in the Policies tab.",
  "Set your Risk Assessment approval policy in the Policies tab.",
];

export function TrusteeWelcomeModal({ open, firstName, onDismiss }: TrusteeWelcomeModalProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onDismiss(false); }}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Welcome{firstName ? `, ${firstName}` : ""}!</DialogTitle>
          <DialogDescription>
            Let's get your Trustee Dashboard set up. Here are the policies to review first:
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-3 py-2">
          {steps.map((step, i) => (
            <li key={i} className="flex gap-3 text-sm">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span>{step}</span>
            </li>
          ))}
        </ul>
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={() => onDismiss(false)}>Remind me later</Button>
          <Button onClick={() => onDismiss(true)}>Got it</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
